<template>
  <div v-if="isQuizLoading" class="quiz-loading">
    <a-spin />
  </div>
  <div class="quiz-content" v-else>
    <div class="quiz__content" v-if="q.name === names.GENDER">
      <div>
        <div class="quiz__title">{{ q.title }}</div>
        <p class="quiz__description quiz__description--sm">
          {{ q.sub_title }}
        </p>
        <div class="quiz__circles quiz__circles--gender">
          <div
            class="quiz__circle quiz__circle--md"
            v-for="g in fields.gender"
            :key="g.value"
          >
            <input
              type="radio"
              name="gender"
              :id="g.value"
              class="quiz__checkbox"
              :value="g.value"
              @click="setQuizForm({ gender: g.value })"
            />
            <label :for="g.value" class="quiz__circle-wrapper">
              <div
                class="quiz__circle-top quiz__circle-top--md"
                :class="g.value === 3 && 'non-binary'"
                v-html="genderIcon[g.text]"
              ></div>
              <div class="quiz__circle-bottom">{{ g.text }}</div>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="quiz__content" v-else-if="q.name === names.AGE">
      <div>
        <div class="quiz__title">{{ q.title }}</div>
        <p class="quiz__description quiz__description--sm">
          {{ q.sub_title }}
        </p>
        <div class="quiz__circles quiz__circles--age">
          <div
            class="quiz__circle quiz__circle--md"
            v-for="a in q.answers"
            :key="a.value"
          >
            <input
              type="radio"
              name="age"
              :id="a.value"
              class="quiz__checkbox"
              :value="a.value"
              @click="setQuizForm({ age: a.value })"
            />
            <label :for="a.value" class="quiz__circle-wrapper">
              <div class="quiz__circle-top quiz__circle-top--md">
                {{ a.text }}
              </div>
              <div class="quiz__circle-bottom">{{ a.label }}</div>
            </label>
          </div>
        </div>
      </div>
      <!-- <div class="quiz-btn__container">
        <button
          :disabled="!quizForm.age"
          class="quiz__btn btn-reset quiz-btn quiz-btn--md quiz-btn--white"
          @click="setQuizForm({})"
        >
          Continue
        </button>
      </div> -->
    </div>
    <div class="quiz__content" v-else-if="q.name === names.TYPICAL_DAY">
      <div>
        <div class="quiz__title">{{ q.title }}</div>
        <p class="quiz__description quiz__description--sm">
          {{
            q.sub_title(
              getGender(quizForm.gender),
              getAge(quizForm.age),
              getGoals(quizForm.goal)
            )
          }}
        </p>
        <div class="quiz__day">
          <div class="quiz__subtitle">{{ q.title_small }}</div>
          <div class="quiz__day-items">
            <div
              class="quiz__day-item-wrapper"
              v-for="t in q.answers"
              :key="t.value"
            >
              <input
                type="radio"
                name="typical_day"
                :id="t.value"
                class="quiz__checkbox"
                :value="t.value"
                @click="setQuizForm({ typical_day: t.value })"
              />
              <label class="quiz__day-item" :for="t.value">
                <img :src="t.img" alt="image" class="quiz__day-item-img" />
                <div class="quiz__day-item-title">{{ t.text }}</div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="quiz-btn__container">
        <button
          :disabled="!quizForm.typical_day"
          class="quiz__btn btn-reset quiz-btn quiz-btn--md quiz-btn--white"
          @click="setQuizForm({})"
        >
          Continue
        </button>
      </div> -->
    </div>
    <div class="quiz__content" v-else-if="q.name === names.OUR_METHOD">
      <div>
        <div class="quiz__title">Our Method</div>
        <p class="quiz__description quiz__description--sm">
          <span class="quiz__description-vs"> vs. </span>
          Conventional Method
        </p>
        <div class="quiz__method">
          <div
            class="quiz__method-wrapper"
            v-for="(m, index) in fields.method"
            :key="m.value"
          >
            <div
              class=""
              :class="
                index % 2
                  ? 'quiz__method-item--right'
                  : 'quiz__method-item--left'
              "
              :for="m.value"
            >
              <img
                v-if="quizForm.gender === 1"
                :src="methodImage[m.text].male"
              />
              <img v-else :src="methodImage[m.text].female" alt="image" />
              <div
                class="quiz__method-title"
                :class="
                  index % 2
                    ? 'quiz__method-title--right'
                    : 'quiz__method-title--left'
                "
              >
                {{ m.text }}
              </div>
            </div>
          </div>
        </div>
        <div class="quiz__subtitle">
          We have helped {{ genderNumber.toFixed(0) }}
          <span>{{ genderTitles[gender.text] }}</span> in their
          {{ ageTitles[genderAge.text] }} {{ genderProblems }}
        </div>
        <div class="quiz__text">
          Our approach works though habit creation that is why it provides
          <br />
          long-lasting results.
        </div>
      </div>
      <div class="quiz-btn__container">
        <button
          class="quiz__btn btn-reset quiz-btn quiz-btn--sm quiz-btn--white"
          @click="setQuizForm({})"
        >
          Ok, got it
        </button>
      </div>
    </div>
    <div class="quiz__content" v-else-if="isRangeQuestion(q.name)">
      <div>
        <div class="quiz__title">{{ q.title }}</div>
        <p
          class="quiz__description quiz__description--sm"
          v-html="q.sub_title"
        ></p>
        <div class="quiz__text" v-html="q.title_capitalize" />
        <div class="quiz__progress">
          <div class="value-slider">{{ quizForm[q.model] }}%</div>
          <a-slider
            class="slider"
            v-model:value="quizForm[q.model]"
            :tooltipVisible="false"
          />
          <div class="text-slider">
            <span>Not at all</span>
            <span>Almost every day</span>
          </div>
        </div>
      </div>
      <div class="quiz-btn__container">
        <button
          class="quiz__btn btn-reset quiz-btn quiz-btn--md quiz-btn--white"
          @click="setQuizForm({})"
        >
          Continue
        </button>
      </div>
    </div>
    <div class="quiz__content" v-else-if="isBooleanQuestion(q.name)">
      <div>
        <div class="quiz__title">{{ q.title }}</div>
        <p class="quiz__description">{{ q.sub_title }}</p>
        <p class="quiz__quote" v-html="q.comment"></p>
        <div class="quiz__circles quiz__circles--choice">
          <div class="quiz__circle quiz__circle--md">
            <input
              type="radio"
              :name="q.name"
              id="43"
              class="quiz__checkbox"
              :value="true"
              v-model="quizForm[q.model]"
              @change="setQuizForm({})"
            />
            <label for="43" class="quiz__circle-wrapper">
              <div class="quiz__circle-top quiz__circle-top--md">
                <img sgv-inline src="@/static/quiz/icons/yes.svg" />
              </div>
              <div class="quiz__circle-bottom quiz__circle-bottom--lg">Yes</div>
            </label>
          </div>
          <div class="quiz__circle quiz__circle--md">
            <input
              type="radio"
              :name="q.name"
              id="44"
              class="quiz__checkbox"
              :value="false"
              v-model="quizForm[q.model]"
              @change="setQuizForm({})"
            />
            <label for="44" class="quiz__circle-wrapper">
              <div class="quiz__circle-top quiz__circle-top--md">
                <img sgv-inline src="@/static/quiz/icons/no.svg" />
              </div>
              <div class="quiz__circle-bottom quiz__circle-bottom--lg">No</div>
            </label>
          </div>
        </div>
      </div>
      <!-- <div class="quiz-btn__container">
        <button
          :disabled="quizForm[q.model] === undefined"
          class="quiz__btn btn-reset quiz-btn quiz-btn--md quiz-btn--white"
          @click="setQuizForm({})"
        >
          Continue
        </button>
      </div> -->
    </div>
    <div
      class="quiz__content space-between"
      v-else-if="q.name === names.LOADER_1"
    >
      <div class="quiz__title">analyzing</div>
      <ProgressBar @done="setQuizForm({})" />
      <div class="quiz__text-bold">Preparing your Improvement plan</div>
    </div>
    <div
      class="quiz__content space-between"
      v-else-if="q.name === names.LOADER_2"
    >
      <div class="quiz__title">analyzing</div>
      <ProgressBar :isContinue="true" @done="setQuizForm({})" />
      <div class="quiz__text-bold">Preparing your Improvement plan</div>
    </div>
    <div
      class="quiz__content space-between"
      v-else-if="q.name === names.LOADER_3"
    >
      <div class="quiz__title">analyzing</div>
      <ProgressBar full @done="setQuizForm({})" />
      <LoaderList />
    </div>
    <div class="quiz__content" v-else-if="q.name === names.TRACKING">
      <div class="quiz__title">Enable Tracking</div>
      <p class="quiz__description quiz__description--sm">
        Tracking allows us to personalize your experience but will also help
        bring Mental Future to more people in need. We will never show any ads
        inside of Mental Future. Please enable tracking to ensure you get the
        optimal experience.
      </p>
      <div class="quiz__tracking-icon">
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M40 21.668c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zM55 28.332H25c0 6.933 3.333 16.667 10 19v14.333h10V47.332c6.667-2.333 10-12.067 10-19z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M53.333 59.398c6 1.034 10 2.8 10 4.767 0 3.333-10.433 5.833-23.333 5.833-12.9 0-23.333-2.6-23.333-5.833 0-1.967 3.933-3.733 10-4.767" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M53.333 52.5c14.6 1.867 25 6.667 25 12.5 0 7.367-17.166 13.333-38.333 13.333-21.167 0-38.333-5.966-38.333-13.333 0-5.733 10.4-10.633 25-12.5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
      <button
        class="quiz__btn btn-reset quiz-btn quiz-btn--sm quiz-btn--white mb-20"
        @click="onEnableTracking"
      >
        Enable
      </button>
      <button
        class="quiz__btn btn-reset quiz-btn quiz-btn--xs quiz-btn--transparent no-margin"
        @click="setQuizForm({})"
      >
        No thanks
      </button>
    </div>
    <div class="quiz__content space-between" v-else-if="q.name === names.EMAIL">
      <div>
        <p class="quiz__text-2">
          Get your personalized Mind Improvement Plan immediately, delivered
          straight to your inbox!
        </p>
        <div class="quiz__input-wrapper">
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'quiz__input-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17.5 9L10 16l-2.5-2.5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.5 24C18.851 24 24 18.851 24 12.5S18.851 1 12.5 1 1 6.149 1 12.5 6.149 24 12.5 24z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <input
            class="quiz__input"
            v-model="quizForm.email"
            placeholder="Your e-mail address"
          />
          <span
            class="error-message"
            v-if="quizForm.email && !checkEmail(quizForm.email)"
            >Please write the correct email address</span
          >
        </div>
      </div>
      <div>
        <p class="quiz__description quiz__description--sm">
          We don’t share any personal information. We’ll email you a copy of
          your results for convenient access.
        </p>
        <div class="quiz-btn__container">
          <button
            :disabled="!quizForm.email || !checkEmail(quizForm.email)"
            class="quiz__btn btn-reset quiz-btn quiz-btn--md quiz-btn--white no-margin"
            @click="setQuizForm({})"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
    <div
      class="quiz__content quiz__content--ld"
      v-else-if="q.name === names.TESTIMONIAL"
    >
      <div>
        <div class="quiz__title-2">{{ getTestimonial(q.index).percent }}</div>
        <p
          class="quiz__description quiz__description--sm"
          v-html="getTestimonial(q.index).title"
        ></p>
      </div>
      <div>
        <swiper
          :space-between="16"
          :slidesPerView="'auto'"
          :pagination="{
            clickable: true,
          }"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            v-for="comment in getTestimonial(q.index).comments"
            :key="comment.id"
          >
            <div class="quiz-comment-card">
              <p class="quiz-comment-card__text">
                {{ comment.text }}
              </p>
              <div class="quiz-comment-card__bottom">
                <img :src="comment.image" />
                <div class="quiz-comment-card__info">
                  <p class="quiz-comment-card__name">{{ comment.name }}</p>
                  <svg width="112" height="16" viewBox="0 0 112 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1283_11983)"><path d="M16 5.56a.327.327 0 00-.313-.227h-5.434L8.333.22a.333.333 0 00-.626 0l-1.92 5.113H.353a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0016 5.56z" fill="#fff"/></g><g clip-path="url(#clip1_1283_11983)"><path d="M40 5.56a.327.327 0 00-.313-.227h-5.434L32.333.22a.333.333 0 00-.626 0l-1.92 5.113h-5.433a.327.327 0 00-.314.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0040 5.56z" fill="#fff"/></g><g clip-path="url(#clip2_1283_11983)"><path d="M64 5.56a.327.327 0 00-.313-.227h-5.434L56.333.22a.333.333 0 00-.626 0l-1.92 5.113h-5.434a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0064 5.56z" fill="#fff"/></g><g clip-path="url(#clip3_1283_11983)"><path d="M88 5.56a.327.327 0 00-.313-.227h-5.434L80.333.22a.333.333 0 00-.626 0l-1.92 5.113h-5.434a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0088 5.56z" fill="#fff"/></g><g clip-path="url(#clip4_1283_11983)"><path d="M112 5.56a.326.326 0 00-.313-.227h-5.434L104.333.22a.331.331 0 00-.626 0l-1.92 5.113h-5.434a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.506-.373l-1.92-5.774 4.48-3.86A.318.318 0 00112 5.56z" fill="#fff"/></g><defs><clipPath id="clip0_1283_11983"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip1_1283_11983"><path fill="#fff" transform="translate(24)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip2_1283_11983"><path fill="#fff" transform="translate(48)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip3_1283_11983"><path fill="#fff" transform="translate(72)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip4_1283_11983"><path fill="#fff" transform="translate(96)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="quiz-btn__container">
        <button
          class="quiz__btn btn-reset quiz-btn quiz-btn--md quiz-btn--white"
          @click="setQuizForm({})"
        >
          Continue
        </button>
      </div>
    </div>
    <div class="quiz__content" v-else-if="q.name === names.MENTAL_INFO">
      <div>
        <div class="quiz__title">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1284_21670)"><path d="M36 3.75a.75.75 0 00-.75-.75h-3V.733a.75.75 0 00-.75-.75h-27a.75.75 0 00-.75.75v2.25h-3a.75.75 0 00-.75.75C0 9.914 1.065 16.17 7.245 16.47c3.63 5.19 8.445 4.26 8.445 9 0 3.72-1.08 6-6 6a.75.75 0 00-.75.75v3a.75.75 0 00.75.75h16.5a.75.75 0 00.75-.75v-3a.75.75 0 00-.75-.75c-4.305 0-6-1.74-6-6 0-4.755 4.83-3.87 8.49-9C34.95 16.184 36 9.78 36 3.75zM1.5 4.5h2.37c.1 3.577.92 7.098 2.415 10.35C2.145 13.933 1.5 8.743 1.5 4.5zm21.42 4.364l-2.22 1.5 1.005 2.85a.75.75 0 01-1.155.855L18 12.15l-2.55 1.92a.75.75 0 01-1.155-.855l1.005-2.85-2.22-1.5A.75.75 0 0113.5 7.5h2.535l1.29-2.58a.78.78 0 011.35 0l1.29 2.58H22.5a.75.75 0 01.42 1.365zm6.765 6a25.83 25.83 0 002.46-10.335H34.5c0 4.2-.66 9.405-4.815 10.32v.015z" fill="#fff"/></g><defs><clipPath id="clip0_1284_21670"><path fill="#fff" d="M0 0h36v36H0z"/></clipPath></defs></svg>
        </div>
        <p class="quiz__text-2 bottom-space-md">
          {{ getQuestionNineTitle }}
        </p>
        <div class="quiz-mental-card__wrapper">
          <div
            v-for="(item, i) in quizMentalCards"
            :key="i"
            class="quiz-mental-card"
            :style="`background: url(${item.bgImage})`"
          >
            <img :src="item.icon" svg-inline />
            <p class="quiz-mental-card__title">{{ item.name }}</p>
          </div>
        </div>
        <div class="grid-cell">
          <div class="flex-center">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.35 9.639L2.528 23.46M25 1S21.35 34.22 3.507 22.493C-8.22 4.651 25 1 25 1z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.906 18.853H7.135v-5.76M15.785 14.246h-4.031v-4.031M18.089 9.638h-1.728V7.91" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <p class="quiz__description">
              Mediation, Music and Nature Sounds created by top coaches,
              storytellers and therapists
            </p>
          </div>
          <div class="flex-center">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1284_21702)" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"><path d="M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5.5 5.649.5 12 5.649 23.5 12 23.5zM18 18l-4.94-4.94"/><path d="M12 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM11.5 6.5v4.08"/></g><defs><clipPath id="clip0_1284_21702"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></svg>
            <p class="quiz__description">
              Vararity of sessions, from 10 minute to 3 hours
            </p>
          </div>
          <div class="flex-center">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1284_21710)" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"><path d="M17.5 23.5a6 6 0 100-12 6 6 0 000 12z"/><path d="M20.5 15.5l-4 4-2-2M3.5 6.5H8M3.5 9.5h8M3.5 12.5h6M3.5 15.5h5M10.5 21.5H.5V.5h11l5 5v4"/><path d="M11.5.5v5h5"/></g><defs><clipPath id="clip0_1284_21710"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></svg>
            <p class="quiz__description">
              Mental Future would learn what is best for you
            </p>
          </div>
        </div>
      </div>
      <div class="quiz-btn__container">
        <button
          class="quiz__btn btn-reset quiz-btn quiz-btn--sm quiz-btn--white"
          @click="setQuizForm({})"
        >
          Continue
        </button>
      </div>
      <span class="loader"></span>
    </div>
    <div class="quiz__content" v-else-if="q.name === names.MENTAL_RECAP">
      <div>
        <div class="quiz__title">Mental Recap</div>
        <p class="quiz__description quiz__description--sm">
          This helps us give you a personalized plan
        </p>
        <div class="quiz__fields">
          <div
            class="quiz__field-wrapper"
            v-for="(mr, i) in mentalRecap"
            :key="i"
          >
            <label class="quiz__label-wrapper-2">
              <div class="quiz__field-icon-2" :class="{ 'top-8': i === 1 }">
                <img svg-inline :src="mr.icon" />
              </div>
              <div>
                <div class="quiz__text-3">{{ mr.title }}</div>
                <div class="quiz__text-4" :class="i % 2 ? 'top-8' : 'top-4'">
                  {{ getRecapValue(i) }}
                </div>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="quiz-btn__container">
        <button
          class="quiz__btn btn-reset quiz-btn quiz-btn--sm quiz-btn--white"
          @click="setQuizForm({})"
        >
          Get Your Personalised Plan
        </button>
      </div>
      <span class="loader"></span>
    </div>
    <div class="quiz__content" v-else>
      <div>
        <div class="quiz__title">{{ q.title }}</div>
        <div class="quiz__description--sm">
          <p class="quiz__description semi-bold" v-html="q.sub_title"></p>
          <p
            class="quiz__description"
            style="margin-top: 8px"
            v-html="q.sub_text"
          ></p>
        </div>
        <div v-if="q.title_small" class="quiz__subtitle">
          {{ q.title_small }}
        </div>
        <div class="quiz__fields">
          <template v-for="(ans, ind) in q.answers" :key="ind">
            <div
              class="quiz__field-wrapper"
              v-if="q.type === types.CHECKBOX || q.type === types.RADIO"
            >
              <input
                v-if="q.type === types.RADIO"
                :type="q.type"
                @input="(e) => (quizForm[q.model] = +e.target.value)"
                :name="q.name"
                :value="ans.value"
                :checked="quizForm[q.model] === ans.value"
                :id="ans.text"
                class="quiz__checkbox"
                @change="setQuizForm({})"
              />
              <input
                v-else
                :type="q.type"
                v-model="quizForm[q.model]"
                :name="q.name"
                :value="ans.value"
                :id="ans.text"
                class="quiz__checkbox"
              />
              <label class="quiz__label-wrapper" :for="ans.text">
                <div
                  v-if="ans.imgType !== imageTypes.IMAGE"
                  class="quiz__field-icon"
                  v-html="ans.img"
                ></div>
                <img class="quiz__field-icon" v-else :src="ans.img" alt="" />
                <div class="quiz__field-text">{{ ans.text }}</div>
                <div class="quiz__field-sub-text">{{ ans.sub_text }}</div>
              </label>
            </div>
          </template>
        </div>
      </div>
      <div class="quiz-btn__container">
        <button
          v-if="q.type !== types.CUSTOM && q.type === types.CHECKBOX"
          :disabled="isDisableBtn(quizForm[q.model])"
          class="quiz__btn btn-reset quiz-btn quiz-btn--md quiz-btn--white"
          @click="setQuizForm({})"
        >
          Continue
        </button>
      </div>
    </div>
    <!-- </template> -->
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import {
  genderIcon,
  goalIcon,
  ageLabel,
  typicalDayImage,
  methodImage,
  emotionsIcon,
  challengesIcon,
  quizComments,
  quizMentalCards,
  mentalRecap,
  goalItems,
  TOTAL_TEST,
  genderTitles,
  ageTitles,
  goalTitles,
  newQuizComments,
} from './quiz-data'
import ProgressBar from '../bar/ProgressBar.vue'
import LoaderList from './LoaderList.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Pagination } from 'swiper'
import { userUpdate } from '@/services/user.service'

SwiperCore.use([Pagination])

import {
  quiz1,
  types,
  names,
  imageTypes,
  quiz2,
  quiz3,
  quiz4,
  quiz5,
  quiz7,
  quizIds,
  booleanQuestions,
  rangeQuestions,
  goalQuestions,
  higherAttributeUsers,
  questionNineTitles,
  questionImprovementTitles,
} from './quizzes'
import { loadFacebookPixel, initFacebook } from '@/utils/facebookConfig'

export default {
  name: 'QuizContent',
  components: { ProgressBar, Swiper, SwiperSlide, LoaderList },
  data() {
    return {
      slider: 30,
      genderIcon,
      goalIcon,
      ageLabel,
      typicalDayImage,
      methodImage,
      emotionsIcon,
      challengesIcon,
      quizComments,
      quizMentalCards,
      mentalRecap,
      goalItems,
      questions: [],
      copyQuestions: [],
      types,
      names,
      imageTypes,
      goalQuestions,
      genderTitles,
      ageTitles,
      goalTitles,
      currentQuiz: [],
    }
  },
  computed: {
    ...mapState('quiz', {
      fields: 'fields',
      current: 'progress',
      quizForm: 'quizForm',
      totalTest: 'totalTest',
      quiz: 'quiz',
      isQuizLoading: 'isQuizLoading',
    }),
    customizedFields() {
      return this.questions.map((i) => {
        let field = this.fields[i.model]
        if (higherAttributeUsers.includes(i.model)) {
          field = this.fields['higher_attribute_repeat']
        }
        if (
          i.type === this.types.CUSTOM ||
          i.type === this.types.RANGE ||
          !field
        )
          return i

        i.answers = i.answers.map((j) => {
          const v = field.find((k) => k.text === j.text) || {}
          return {
            ...j,
            value: v.value,
          }
        })
        return i
      })
    },
    isQuiz5() {
      return this.quiz.quiz === quizIds.QUIZ_5
    },
    isQuiz7() {
      return this.quiz.quiz === quizIds.QUIZ_7
    },
    q() {
      return this.customizedFields[this.current - 1]
    },
    ...mapState(['user', 'token']),
    filteredGoalItems() {
      return this.fields.goal.filter((i) =>
        this.quizForm.goal.includes(i.value)
      )
    },
    goalItemQuestions() {
      return this.filteredGoalItems.map((i) => this.goalQuestions[i.text])
    },
    testimonial() {
      const t = [],
        newQuizzes = []

      this.filteredGoalItems.forEach((i) => {
        t.push(this.quizComments[i.text])
        newQuizzes.push(newQuizComments[i.text])
      })
      const randomNum = Math.floor(Math.random() * t.length)

      const getRandomItems = (num) => {
        const shuffled = newQuizzes.sort(() => 0.5 - Math.random())
        return shuffled.slice(0, num)
      }
      const randomItems = getRandomItems(2)
      return this.isQuiz7
        ? randomItems.length === 2
          ? randomItems
          : [...randomItems, t[randomNum]]
        : [t[randomNum]]
    },
    getQuestionNineTitle() {
      const t = []
      this.filteredGoalItems.forEach((i) => {
        t.push(questionNineTitles[i.text])
      })

      if (this.isQuiz7) {
      }

      const randomNum = Math.floor(Math.random() * t.length)

      return t[randomNum]
    },
    genderNumber() {
      return Math.random() * (5000 - 1000) + 1000
    },
    gender() {
      return (
        (this.fields.gender &&
          this.fields.gender.find((i) => i.value === this.quizForm.gender)) ||
        {}
      )
    },
    genderAge() {
      return (
        (this.fields &&
          this.fields.age.find((i) => i.value === this.quizForm.age)) ||
        {}
      )
    },
    genderProblems() {
      return (
        (this.fields &&
          this.fields.goal
            .filter((i) => this.quizForm.goal.includes(i.value))
            .map((i) => this.goalTitles[i.text])
            .join(', ')) ||
        []
      )
    },
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        if (this.user.email) this.quizForm.email = this.user.email
      },
    },
    quiz: {
      immediate: true,
      handler() {
        switch (this.quiz.quiz) {
          case quizIds.QUIZ_1:
            this.questions = quiz1
            break
          case quizIds.QUIZ_2:
            this.questions = quiz2
            break
          case quizIds.QUIZ_3:
            this.questions = quiz3
            break
          case quizIds.QUIZ_4:
            this.questions = quiz4
            break
          case quizIds.QUIZ_5:
            this.questions = quiz5
            break
          case quizIds.QUIZ_7:
            this.questions = quiz7
            break
        }
        if (this.quiz.quiz) {
          this.copyQuestions = this.questions
          this.SET_TOTAL_TEST(this.questions.length)
        }
      },
    },
    'quizForm.goal': {
      immediate: true,
      handler() {
        if (this.isQuiz5) {
          this.SET_TOTAL_TEST(
            this.copyQuestions.length + this.quizForm.goal.length
          )
          this.questions = [
            this.copyQuestions[0],
            ...this.goalItemQuestions,
            ...this.copyQuestions.slice(1),
          ]
        }
      },
    },
  },
  async mounted() {
    this.loadFacebookPixel('StartedQuiz')
  },
  methods: {
    ...mapMutations('quiz', [
      'SET_PROGRESS',
      'SET_QUIZ_FORM',
      'SET_TOTAL_TEST',
    ]),
    loadFacebookPixel,
    getTestimonial(index) {
      return this.testimonial[index] || {}
    },
    getGender(id) {
      const g = this.fields.gender.find((i) => i.value === id)
      return g && g.text
    },
    getAge(id) {
      const g = this.fields.age.find((i) => i.value === id)
      return g && g.text
    },
    getGoals(ids) {
      const g = this.fields.goal.filter((i) => ids.includes(i.value))
      return g.map((i) => i.text).join(', ')
    },
    async setQuizForm(value) {
      this.SET_QUIZ_FORM({ ...this.quizForm, ...value })
      if (this.current >= this.totalTest && this.token) {
        if (this.$route.query.redirect) {
          this.isLoading = true
          delete this.quizForm.email
          try {
            await userUpdate(this.quizForm)
          } catch (e) {
            console.log(e)
          }
          this.$router.push({ name: this.$route.query.redirect })
          return
        }
        this.$router.push({ name: 'QuizResults' })
        return
      }

      this.SET_PROGRESS(this.current + 1)
    },
    checkEmail(email) {
      return /\S+@\S+\.\S+/.test(email)
    },
    isBooleanQuestion(name) {
      return booleanQuestions.includes(name)
    },
    isRangeQuestion(name) {
      return rangeQuestions.includes(name)
    },
    isTest(testNum) {
      return this.current === testNum + this.quizForm.goal.length - 1
    },
    getRecapValue(i) {
      switch (i) {
        case 0:
          return this.filteredGoalItems.map((i) => i.text).join(', ')
        case 1:
          return this.filteredGoalItems
            .map((i) => {
              return questionImprovementTitles[i.text]
            })
            .join(', ')
        case 2:
          return this.fields.challenges
            .filter((j) => this.quizForm.challenges.includes(j.value))
            .map((j) => j.text)
            .join(', ')
        case 3:
          const f =
            this.quizForm.feel < 50
              ? 'mildly'
              : this.quizForm.feel > 50
              ? 'very'
              : ''
          return `You are feeling ${f} optimistic which means you have more than ${this.quizForm.feel}% chance   of success`
      }
    },
    isDisableBtn(element) {
      if (Array.isArray(element)) {
        return !element.length
      }
      return !element
    },
    onSwiper() {},
    onSlideChange() {},
    onEnableTracking() {
      navigator.geolocation.getCurrentPosition(
        (e) => {
          console.log(e)
          this.setQuizForm({})
        },
        (e) => {
          console.log('rejected ', e)
          this.setQuizForm({})
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.no-margin {
  margin: 0%;
}

.uppercase {
  text-transform: uppercase;
}

.mb-20 {
  margin-bottom: 20px;
}
.progress {
  width: 327px;
  margin: 0 auto;
}

.quiz__content {
  @media (max-width: 768px) {
    padding-bottom: 100px;
    height: calc(100vh - 63px);
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .ant-progress-circle-trail {
    stroke: #ffffff1a;
  }

  ::v-deep .swiper-container {
    display: flex;
    flex-direction: column-reverse;
  }

  ::v-deep .swiper-pagination {
    display: flex;
    margin-top: 36px;
    justify-content: center;
    column-gap: 8px;
  }

  ::v-deep .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    background: rgba(#fff, 0.1);
    border-radius: 50%;
    display: block;
    cursor: pointer;
  }

  ::v-deep .swiper-pagination-bullet-active {
    background: #ffffff;
  }
}

.error-message {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  text-align: center;
  display: block;
  margin-top: 4px;
  padding: 0;
}

.quiz-loading {
  display: grid;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 112px);
}

.quiz-btn__container {
  @media (max-width: 768px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    background: #4e8b72;

    .quiz-btn {
      margin: 15px 0;
    }
  }
}
</style>
